import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { Loading } from "../../../../componentes/loading/loading";

export default function ResumoStatus({ loading, filtrar, data, openModal }) {
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);
  const [tamanho, settamanho] = useState(0);

  useEffect(() => {
    const labels = data.map((item) => item.status || "Indefinido");
    const values = data.map((item) => item.total || 0);
    settamanho(data.length);

    setChartOptions({
      chart: {
        type: "donut",
        events: {
          dataPointSelection: (event, chartContext, config) => {
            const index = config.dataPointIndex;
            const label = labels[index];
            openModal(label, "status");
          },
        },
      },
      labels,
      legend: {
        position: "bottom",
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: "bottom",
            },
          },
        },
      ],

      stroke: {
        show: false,
        width: 0,
      },
      plotOptions: {
        pie: {
          donut: {
            size: "50%", // aumenta a espessura da rosca
          },
        },
      },
      colors: [
        "#3B82F6", // aberto
        "#FF6553", // cancelado
        "#17b34dff", // finalizado
      ],
    });

    setChartSeries(values);
  }, [data]);

  return (
    <div className="bg-card border border-border rounded-lg shadow-card p-4 lg:col-span-1">
      <h3 className="text-lg font-display font-semibold text-foreground mb-1">
        Distribuição por Status
      </h3>
      <label className="text-muted-foreground text-sm">
        Visão geral dos processos por situação atual.
      </label>
      <div className="h-64">
        {!loading && tamanho > 0 ? (
          <Chart
            options={chartOptions}
            series={chartSeries}
            type="donut"
            height="100%"
          />
        ) : !loading ? (
          "Não existem dados disponíveis para o intervalo selecionado."
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
}